module.exports = "/_next/static/files/7c4ed99e1f68448e76a69aa06e9b5439.jpg";